function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _fakeBaseInCasesWhereUrlIsRelative = /*#__PURE__*/new WeakMap();
var _trailingSlash = /*#__PURE__*/new WeakMap();
var _processUrlTrailingSlash = /*#__PURE__*/new WeakMap();
var UrlProcessor = /*#__PURE__*/function () {
  "use strict";

  function UrlProcessor(trailingSlash) {
    var _this = this;
    _classCallCheck(this, UrlProcessor);
    _classPrivateFieldInitSpec(this, _fakeBaseInCasesWhereUrlIsRelative, 'http://hack');
    _classPrivateFieldInitSpec(this, _trailingSlash, void 0);
    _classPrivateFieldInitSpec(this, _processUrlTrailingSlash, function (url) {
      if (!UrlProcessor.validSchemes.some(function (scheme) {
        return url.startsWith(scheme);
      })) {
        // any combination of slashes at the beginning URL class classifies as an absolute link with http: protocol, so we remove them at the end
        url = url.replace(/^[\/\\]+/gi, '/');
      }
      var parsedUrl = new URL(url, _classPrivateFieldGet(_fakeBaseInCasesWhereUrlIsRelative, _this));
      if (parsedUrl.username || parsedUrl.password) {
        return '/';
      }

      // Ensure there are no double slashes in the pathname, excluding the start
      parsedUrl.pathname = parsedUrl.pathname.replace(/\/{2,}/g, '/');
      var doesUrlPathnameEndWithTrailingSlash = parsedUrl.pathname[parsedUrl.pathname.length - 1] === '/';
      switch (_classPrivateFieldGet(_trailingSlash, _this)) {
        case UrlProcessor.routerHasTo.redirectToNonTrailingSlash:
          {
            if (doesUrlPathnameEndWithTrailingSlash) {
              parsedUrl.pathname = parsedUrl.pathname.slice(0, -1);
            }
            break;
          }
        case UrlProcessor.routerHasTo.redirectToTrailingSlash:
          {
            if (!doesUrlPathnameEndWithTrailingSlash) {
              parsedUrl.pathname = parsedUrl.pathname.concat('/');
            }
            break;
          }
      }
      var resultUrl = parsedUrl.toString().replace(_classPrivateFieldGet(_fakeBaseInCasesWhereUrlIsRelative, _this), '');

      // Strip any trailing double slashes from the pathname, if present
      resultUrl = resultUrl.replace(/\/{2,}$/g, '/');
      return resultUrl;
    });
    _classPrivateFieldSet(_trailingSlash, this, trailingSlash);
  }
  return _createClass(UrlProcessor, [{
    key: "process",
    value: function process(url) {
      switch (_classPrivateFieldGet(_trailingSlash, this)) {
        case UrlProcessor.routerHasTo.redirectToNonTrailingSlash:
        case UrlProcessor.routerHasTo.redirectToTrailingSlash:
          {
            return _classPrivateFieldGet(_processUrlTrailingSlash, this).call(this, url);
          }
        case UrlProcessor.routerHasTo.doNothing:
        default:
          {
            return url;
          }
      }
    }
  }]);
}();
_defineProperty(UrlProcessor, "validSchemes", ['http://', 'https://']);
_defineProperty(UrlProcessor, "routerHasTo", {
  doNothing: 'doNothing',
  redirectToNonTrailingSlash: 'redirectToNonTrailingSlash',
  redirectToTrailingSlash: 'redirectToTrailingSlash'
});
module.exports = UrlProcessor;